module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('data-table', {
    attrs: {
      "table-ref": "structtable",
      "title": _vm.title,
      "title-heading": "h2",
      "icon": "fa fa-broadcast-tower",
      "url": '/struct/' + (this.siteId ? '/site/' + this.siteId : '') + (this.owner ? '/org/' + this.owner : ''),
      "fields": _vm.fields,
      "hide-top": _vm.hideTop,
      "hide-org-badge": "",
      "show-search": _vm.showSearch,
      "show-refresh": _vm.showRefresh,
      "search-placeholder": _vm.searchPlaceholder,
      "add-action": _vm.noAdd ? null : _vm.action,
      "add-props": _vm.noAdd ? null : _vm.addPropsData,
      "detail-component": "struct-detail-row"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bb18478"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tables/StructTable.vue
// module id = 1466
// module chunks = 0